<template>
    <div class="content policy">
        <v-row v-if="page">
            <v-col cols="12" class="pa-6 pa-md-12 d-flex flex-column">
                <h1 class="pb-6">
                    {{page.title}}
                </h1>
                <p class="policy-top">
                    {{page.topContent}}
                </p>
                <ul>
                    <li v-for="(policy, i) in page.privacy_policies" :key="i">
                        {{policy.content}}
                    </li>
                </ul>
                <p class="policy-bottom">
                    {{page.bottomContent}}
                </p>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import SiteService from "../services/site.service";
import { flattenObj } from '../utils/utils';

export default {
  name: 'Policy',
    data() {
      return {
          page: null
      }
    },
    async beforeMount() {
        const response = await SiteService.getPolicyPage();
        this.page = flattenObj(response);
    }
}
</script>

<style scoped>
    div.content {
        max-width: 1024px;
    }

    .policy .policy-top {
        font-size: 14px !important;
        font-weight: 400 !important;
        margin-bottom: 20px !important;
    }
    .policy .policy-bottom {
        font-size: 14px !important;
        font-weight: 400 !important;
        margin-top: 20px;
    }
    .policy ul {

    }
    .policy li {
        font-size: 14px !important;
        font-weight: 400 !important;
    }
    .policy h1 {
        font-size: 26px !important;
        font-weight: 700 !important;
    }

</style>
